<template>
	<div :class="['form-container', 'input-button', 'btn btn-sm', 'position-relative', { 'btn-primary': settings.isPrimary, 'btn-warning': settings.isWarning, 'btn-danger': settings.isDanger, 'btn-outline-primary': !settings.isPrimary && !settings.isWarning && !settings.isDanger }]" v-if="settings.visible && settings.userHasAccess" :disabled="settings.disabled ? true : null" :title="settings.tooltipEnabled ? tooltip : ''">
		<div class="group" ref="group">
			<span v-if="!settings.hideIcon && settings.icon && settings.icon != ''" :icon="settings.icon" class="icon" @click.stop="toggleExpand">
				<i :class="settings.icon"> </i>
			</span>
			<span v-if="!settings.hideTitle && settings.title != ''" class="button-title">{{ settings.title }}</span>
			<nk-input class="hide-element" ref="input" v-model="val" :options="settings.inputOptions" :tabindex="104" :class="options.class" :style="options.style" startup></nk-input>
			<span :tabindex="111" :icon="settings.submitIcon" class="submit hide-element" @click.stop="$emit('submit', val, $event)" ref="submit">
				<i class="fal fa-check"></i>
			</span>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'

	export default {
		props: {
			options: {
				type: Object,
				required: true
			}
		},
		emits: ['optionsChanged', 'submit'],
		data() {
			return {
				settings: {
					isPrimary: false,
					isWarning: false,
					isDanger: false,
					disabled: false,
					visible: true,
					userHasAccess: null,
					icon: 'fal fa-arrows-v',
					title: '',
					hideShortcut: false,
					hideTitle: false,
					hideIcon: false,
					tooltipEnabled: false,
					shortcut: {
						keyCode: 0,
						ctrlKey: false,
						shiftKey: false,
						altKey: false,
						display: ''
					},
					policyToken: null,
					inputOptions: {
						searchable: false,
						required: true,
						mode: 'integer'
					},
					submitIcon: 'check',
				},
				val: ''
			}
		},
		computed: {
			shortcutDisplay() {
				var arr = []
				var sc = this.settings.shortcut

				if (sc.keyCode > 0) {
					if (sc.ctrlKey === true) {
						arr.push('Ctrl')
					}
					if (sc.shiftKey === true) {
						arr.push('Shift')
					}
					if (sc.altKey === true) {
						arr.push('Alt')
					}

					var key = sc.keyCode
					var keyChar = String.fromKeyCode(key)
					keyChar = keyChar || ''

					arr.push(keyChar)
					return arr.join(' + ')
				} else {
					return ''
				}
			},
			tooltip() {
				let parts = []

				if (this.settings.title && this.settings.title.length > 0) {
					parts.push(this.settings.title)
				}

				if (this.shortcutDisplay.length > 0) {
					parts.push(this.shortcutDisplay)
				}

				return parts.join(' ').trim()
			}
		},
		mounted() {
			this.settings = _.extend(this.settings, this.options)
			this.checkUserPermission()
		},
		methods: {
			checkUserPermission() {
				let hasAccess = true

				if (this.settings.policyToken != null) {
					hasAccess = this.$nikan.checkPermission(this.settings.policyToken)
				}

				if (this.settings.userHasAccess !== hasAccess) {
					this.settings.userHasAccess = hasAccess
					this.$emit('optionsChanged', this.settings)
				}
			},
			toggleExpand() {
				if (this.$refs.input && $(this.$refs.input.$el).is(":visible")) {
					$(this.$refs.input.$el).animate({ width: 'toggle' })
					$(this.$refs.submit).fadeOut()
				}
				else {
					$(this.$refs.input.$el).animate({ width: 'toggle' })
					$(this.$refs.submit).fadeIn()
				}
			},
			subscribeKeys() {
				if (this.$refs.input) {
					this.$keyHandler.Subscribe({
						name: 'nikan-input-button-submit',
						keyCode: 13,
						el: this.$refs.input.$el,
						context: this,
						handler: function (sender, e) {
							this.$emit('submit', this.val, e)
							return true
						}
					})
				}
			}
		}
	}
</script>
<style>
	.input-button {
		display: inline-block;
		padding: 0;
	}

	.input-button .group {
		align-items: center;
		display: flex;
	}

	.input-button .group .icon {
		padding: 3px 9px;
	}

	.input-button .group input {
		height: 18px;
		width: 50px !important;
	}

	.input-button .group .submit {
		margin-left: 5px;
		margin-right: 5px;
	}

	.input-button .hide-element {
		display: none;
	}

</style>
